<template>
  <div class="reports-list">
    <div v-for="report in reports" :key="report.id" class="report">
      <div class="report-icon">
        <font-awesome-icon icon="file-excel" />
      </div>
      <div class="report-name">
        <a href="javascript:void" @click.prevent="download(report.id, report.originalName)">{{
          report.originalName
        }}</a>
      </div>
      <div class="report-date">
        {{ formatDate(report.createdAt) }}
      </div>
      <div class="report-delete">
        <button id="deleteButton" @click="deleteReport(report.id)">
          <font-awesome-icon icon="trash-alt" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { attachmentService } from '@/app/components/attachments/attachment.service';
import formatDatetime from '@/filters/format-datetime.filter.js';
export default {
  name: 'GeneratedReportsList',
  props: {
    reports: {
      type: Array,
      required: true
    }
  },
  methods: {
    isInvoice(attachment) {
      return attachment.category === 'Invoice';
    },
    download(attachmentId, originalName) {
      attachmentService.download(attachmentId, originalName);
    },
    async deleteReport(attachmentId) {
      await attachmentService.deleteAttachment(attachmentId, true);
      this.$emit('refresh');
    },
    formatDate(d) {
      return d ? formatDatetime(d) : null;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../styles/colors.scss';
@import '../../../styles/variables.scss';

.reports-list {
  background-color: $background-level-2;
  .report {
    display: flex;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: $details-padding;
    padding-right: $details-padding;
    &:not(:last-of-type) {
      border-bottom: 1px solid $row-border;
    }
  }
  .report-name {
    display: inline-block;
    margin-left: 31px;
    color: $text-color-dark;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.16px;
    line-height: 19px;
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .report-icon {
    display: inline-block;
    position: relative;
    color: $text-color-dark-3;
    background-color: $background-light;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.2em;
    }
  }
  .report-date {
    display: inline-block;
    font-size: 16px;
  }

  .checkbox-label {
    display: inline-block;
    margin-left: 10px;
  }

  .dropdown-label {
    display: inline-block;
    margin-left: 10px;
  }

  .report-delete {
    float: right;
    padding: 10px;
    & button {
      cursor: pointer;
    }
  }
}
</style>
